export default {
  operationGetAds:'/v1/5c94aa1a043e7' ,// 获取指定广告位的广告列表
  operationSuggestionsType:"/v1/5d63ba953ee01" ,// 获取投诉反馈类型
  addSuggestionsOffice:"/v1/612d9268e28e3" ,// 联系我们
  orderTrajectory:"/v1/612d907c1c2a5" ,// 查询订单轨迹-1
  getArticleDetail:"/v1/6131bf445451c" // 获取关于我们信息
}



// WEBPACK FOOTER //
// ./src/axios/api.js